import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCheck, FiArrowRight, FiRefreshCw } = FiIcons;

const included = [
  'Current-state assessment of asset tracking and support flow',
  'JSM environment design and build',
  'Asset schema, request types, queues, and SLA configuration',
  'Automation setup for routing, assignments, and notifications',
  'Existing asset data migration from spreadsheets',
  'Portal setup for internal request submission',
  'Team walkthrough and go-live support',
  'Ongoing retainer for admin, config changes, and expansions',
];

const managed = [
  'Designs and builds your JSM asset + helpdesk environment',
  'Migrates your existing asset data into the system',
  'Configures routing, automations, and SLAs',
  'Maintains and updates the system on retainer',
  'Adds new asset types, locations, or workflows as you grow',
  'Keeps your configuration clean as your operation evolves',
  'Gives managers real visibility into assets and open tickets',
];

const HomeService = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  return (
    <section id="service" className="py-24" style={{ background: '#f0fdf4' }}>
      <div className="max-w-5xl mx-auto px-8 lg:px-16">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-6">
          <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#16a34a' }}>The Service</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#052e16' }}>JSM Asset Ops Partner</h2>
          <div className="inline-block px-4 py-2 rounded-lg mb-4" style={{ background: '#dcfce7', border: '1px solid #86efac' }}>
            <p className="text-sm font-bold" style={{ color: '#052e16' }}>
              Fixed-fee build. Retainer for ongoing support. No open-ended consulting.
            </p>
          </div>
          <p className="text-base leading-relaxed max-w-2xl" style={{ color: '#166534' }}>
            We build and maintain JSM-based asset management and internal helpdesk systems for operations and IT managers at asset-heavy companies. You get a proper system in 4–6 weeks — and a retainer so it never becomes your next cleanup project.
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="p-8 rounded-xl border" style={{ background: '#052e16', borderColor: '#166534' }}>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: 'rgba(74,222,128,0.15)' }}>
                <SafeIcon icon={FiRefreshCw} className="w-5 h-5" style={{ color: '#4ade80' }} />
              </div>
              <div>
                <h3 className="text-base font-bold text-white">What Valtivo handles</h3>
                <span className="text-xs font-bold px-2 py-0.5 rounded" style={{ background: 'rgba(74,222,128,0.15)', color: '#4ade80' }}>Build + retainer</span>
              </div>
            </div>
            <div className="space-y-3">
              {managed.map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <SafeIcon icon={FiCheck} className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" style={{ color: '#4ade80' }} />
                  <span className="text-sm leading-relaxed" style={{ color: '#bbf7d0' }}>{item}</span>
                </div>
              ))}
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: 0.08 }} className="p-8 rounded-xl border" style={{ background: '#ffffff', borderColor: '#bbf7d0' }}>
            <p className="text-xs font-bold uppercase tracking-wider mb-5" style={{ color: '#16a34a' }}>What's included</p>
            <div className="space-y-3">
              {included.map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-4 h-4 rounded flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#dcfce7' }}>
                    <SafeIcon icon={FiCheck} className="w-2.5 h-2.5" style={{ color: '#16a34a' }} />
                  </div>
                  <span className="text-sm leading-relaxed" style={{ color: '#166534' }}>{item}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
        <div className="p-5 rounded-xl border" style={{ background: '#ffffff', borderColor: '#bbf7d0' }}>
          <p className="text-xs leading-relaxed" style={{ color: '#166534' }}>
            <strong style={{ color: '#052e16' }}>The build is fixed-fee. The retainer is monthly.</strong> Scope is confirmed during discovery. This is not open-ended consulting or custom software development.
          </p>
        </div>
        <div className="text-center mt-10">
          <button onClick={() => scrollTo('booking')} className="group inline-flex items-center gap-2 px-8 py-4 rounded font-bold text-base" style={{ background: '#16a34a', color: '#ffffff' }}>
            Talk Through Your Setup
            <SafeIcon icon={FiArrowRight} className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeService;